import { useEffect } from "react";

const MAG_STRENGTH = 0.22;
const MAG_MAX = 7;

/* Desktop-only pointer effects: card spotlight + magnetic primary buttons. */
export default function InteractiveFx() {
    useEffect(() => {
        if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return undefined;
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;

        let raf = 0;
        let last = null;
        let magnet = null;

        const apply = () => {
            raf = 0;
            if (!last) return;
            const card = last.target.closest?.(".itly-card");
            if (card) {
                const r = card.getBoundingClientRect();
                card.style.setProperty("--mx", `${last.clientX - r.left}px`);
                card.style.setProperty("--my", `${last.clientY - r.top}px`);
            }
            const btn = last.target.closest?.(".itly-btn-primary");
            if (btn !== magnet) {
                if (magnet) magnet.style.transform = "";
                magnet = btn;
            }
            if (btn) {
                const r = btn.getBoundingClientRect();
                const dx = (last.clientX - (r.left + r.width / 2)) * MAG_STRENGTH;
                const dy = (last.clientY - (r.top + r.height / 2)) * MAG_STRENGTH;
                const cx = Math.max(-MAG_MAX, Math.min(MAG_MAX, dx));
                const cy = Math.max(-MAG_MAX, Math.min(MAG_MAX, dy));
                btn.style.transform = `translate(${cx}px, ${cy}px)`;
            }
        };
        const onMove = (e) => {
            last = e;
            if (!raf) raf = requestAnimationFrame(apply);
        };
        document.addEventListener("pointermove", onMove, { passive: true });
        return () => {
            document.removeEventListener("pointermove", onMove);
            if (raf) cancelAnimationFrame(raf);
            if (magnet) magnet.style.transform = "";
        };
    }, []);
    return null;
}
